import { useEffect } from "react";
import { v4 as uuid } from "uuid";

export default function DifyChatbot() {
  const token = process.env.REACT_APP_DIFY_TOKEN || "d6JRjXh0FuLoDoIu";
  const baseUrl =
    process.env.REACT_APP_DIFY_BASE_URL || "https://chat.fizmasoft.uz";

  const user = JSON?.parse(localStorage?.getItem("user"));
  const userId = user?.user?.id ?? null;

  useEffect(() => {
    const stored = localStorage.getItem("dify-conversation");
    const conversationId = stored || uuid();
    if (!stored) localStorage.setItem("dify-conversation", conversationId);

    if (!document.getElementById("dify-config")) {
      const cfg = document.createElement("script");
      cfg.id = "dify-config";
      cfg.innerHTML = `
        window.difyChatbotConfig = {
          token: '${token}',
          baseUrl: '${baseUrl}',
          systemVariables: {
            user_id: '${userId}'
          }
        };
      `;
      document.body.appendChild(cfg);
    }

    if (!document.getElementById(token)) {
      const s = document.createElement("script");
      s.id = token;
      s.src = `${baseUrl}/embed.min.js`;
      s.defer = true;
      document.body.appendChild(s);
    }
  }, [token, baseUrl, userId]);

  return null;
}
